export default class SliderController {
    constructor() {
        this.swiper = null;
        this.sliders = [];

        this.init();
    }

    init() {
        if (document.querySelectorAll('.swiper-container').length) {
            if (typeof Number.isNaN == 'undefined') {
                Number.isNaN = number => number === NaN;
            }

			import( /* webpackChunkName: "modules/slider" */ 'swiper').then(e => {
                this.swiper = e.Swiper;
                this.swiper.use([e.Navigation, e.Scrollbar, e.Pagination, e.Autoplay]);

                document.querySelectorAll('.swiper-container').forEach(container => {

                    let settings = {
                        spaceBetween: 40,
                        grabCursor: true,
                        threshold: 10,
                        slidesPerView: 'auto',
                        on: {},
                    };

                    if (container.parentElement.querySelector('.swiper-pagination')) {
                        if (container.querySelectorAll('.swiper-slide').length > 1) {
                            settings.pagination = {
                                el: container.parentElement.querySelector('.swiper-pagination'),
                                clickable: true,
                            };
                        } else {
                            container.parentElement.querySelector('.swiper-pagination').remove();
                        }
                    }

                    settings = Object.assign(settings, this.getSpecificOptions(container));

                    if (container.parentElement.querySelector('.indicator')) {
                        settings.on.sliderMove = () => {
                            container.parentElement.querySelector('.indicator').classList.add('hidden');
                        };
                    }
                    
                    const slider = new this.swiper(container, settings);

                    this.sliders.push(slider);

                    // Modify slider events if needed
                    this.specificActions(slider, container);
                });
			});
		}
    }

    getSpecificOptions(container) {
        let settings = {
            breakpoints: {},
        };

        settings.breakpoints[app.breakpoints.xs.size] = {
            spaceBetween: app.breakpoints.xs.gutter,
            slidesPerView: 'auto',
        };

        settings.breakpoints[app.breakpoints.sm.size] = {
            spaceBetween: app.breakpoints.sm.gutter,
            slidesPerView: 'auto',
        };

        settings.breakpoints[app.breakpoints.md.size] = {
            spaceBetween: app.breakpoints.md.gutter,
            slidesPerView: 'auto',
        };

        settings.breakpoints[app.breakpoints.ml.size] = {
            spaceBetween: app.breakpoints.ml.gutter,
            slidesPerView: 'auto',
        };

        settings.breakpoints[app.breakpoints.lg.size] = {
            spaceBetween: app.breakpoints.lg.gutter,
            slidesPerView: 'auto',
        };

        settings.breakpoints[app.breakpoints.xl.size] = {
            spaceBetween: app.breakpoints.xl.gutter,
            slidesPerView: 'auto',
        };

        if (container.classList.contains('automaticCarousel')) {
            settings.breakpoints[app.breakpoints.xs.size].slidesPerView = 1.1;
            settings.breakpoints[app.breakpoints.sm.size].slidesPerView = 1.1;
            settings.breakpoints[app.breakpoints.md.size].slidesPerView = 1.8;
            settings.breakpoints[app.breakpoints.ml.size].slidesPerView = 2.2;
            settings.breakpoints[app.breakpoints.lg.size].slidesPerView = 2.5;
            settings.breakpoints[app.breakpoints.xl.size].slidesPerView = 3.2;

            settings.loop = true;

            // settings.centerSlides = true;
            // settings.speed = 6000;
            // settings.autoplay = {
            //     delay: 1,
            // };
            // settings.allowTouchMove = false,
            // settings.disableOnInteraction = true;

            // settings.autoplay = {
            //     delay: 1
            // };
            // settings.freeMode = true;
            // settings.speed = 5000;
            // settings.slidesPerGroup = 4;


            // settings.centeredSlides = true;
            settings.speed = 1000;
            settings.autoplay = {
                delay: 2500,
            };
            settings.navigation = {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
              };
        }

        return settings;
    }

    specificActions(slider, container) {
        if (container.classList.contains('automaticCarousel')) {
            let interval = null;
            // const getOffset = transform => {
                // return parseInt(transform.substr(transform.indexOf('(') + 1, (transform.indexOf(',') - transform.indexOf('(') - 1)));
            // }
            const run = () => {
                // let moveBy = 1;
                // // Get current transform
                // let transform = container.querySelector('.swiper-wrapper').style.transform;
                // // Get its x offset, use it as base
                // let offset = getOffset(transform);
    
                // if (offset) {
                //     interval = setInterval(() => {
                //         container.querySelector('.swiper-wrapper').style.transform = `translate3d(${offset + moveBy}px, 0, 0)`;
                //         moveBy--;
                //     }, 30);
            }

            container.addEventListener('mouseenter', () => {
                slider.autoplay.stop();

                if (interval) {
                    clearInterval(interval);
                    interval = null;
                }
            });

            container.addEventListener('mouseleave', () => {
                slider.autoplay.start();

                if (!interval) {
                    run();
                }
            });

            run();
        }
    }
}